import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import { DEFAULT_PRIMARY_FONT_FAMILY } from 'theme/fontDefaults';

const StTQPageWrapperContainer = styled(Grid)(({ theme }) => {
  return {
    '.mail-text': {
      lineHeight: '160%',
      paddingTop: '1rem',
      paddingBottom: '1rem',
      textAlign: 'left',
    },
    '.subtitle': {
      fontSize: '1rem',
      padingBottom: '5px',
      fontFamily: `${
        theme?.palette?.primaryFontFamilyType || DEFAULT_PRIMARY_FONT_FAMILY
      }, sans-serif`,
      color: theme.palette.black.main,
    },
    [theme.breakpoints.down('md')]: {
      '.sub-title': {
        fontSize: '1.5rem',
        fontWeight: '400',
      },
    },
  };
});

export default StTQPageWrapperContainer;
